import { Typography } from "antd"

import { modalConfig } from "../../../theme"

const { Text } = Typography

export const changeStatusConfirm = (data, callBack, { modal, isMobile }) => {
  modal.confirm({
    ...modalConfig("exclamation"),
    centered: !isMobile,

    title: "Confirm status changing",
    content: (
      <>
        <Text type="secondary">{`Are you sure you want to set ${data?.status} status for this invoice?`}</Text>
        <br />
        <Text type="secondary">This action can NOT be undone.</Text>
      </>
    ),
    cancelText: "Cancel",
    okText: "Confirm",
    //cancelButtonProps: {size: 'large'},
    okButtonProps: {
      ...modalConfig("exclamation")?.okButtonProps,
      danger: true,
      ghost: true
    },
    onOk() {
      callBack({ ...data })
    }
  })
}

export const confirmInvoiceAmount = (data, callBack, { modal, isMobile }) => {
  modal.confirm({
    ...modalConfig("question"),
    centered: !isMobile,

    title: "Confirm the invoice amount",
    content: (
      <>
        <Text type="secondary">
          Are you sure you want to confirm this invoice with the current amount so it will be
          available for the user?
        </Text>
        <br />
        <Text type="secondary">This action can NOT be undone.</Text>
      </>
    ),
    cancelText: "Cancel",
    okText: "Confirm",
    //cancelButtonProps: {size: 'large'},
    okButtonProps: {
      ...modalConfig("exclamation")?.okButtonProps,
      danger: true,
      ghost: true
    },
    onOk() {
      callBack({ ...data })
    }
  })
}

export const confirmUpdatedInvoiceAmount = (data, callBack, { modal, isMobile }) => {
  modal.confirm({
    ...modalConfig("question"),
    centered: !isMobile,

    title: "Confirm the updated invoice amount",
    content: (
      <>
        <Text type="secondary">
          Are you sure you want to confirm this invoice with the current amount so it will be
          available for the user?
        </Text>
        <br />
        <Text type="secondary">This action can NOT be undone.</Text>
      </>
    ),
    cancelText: "Cancel",
    okText: "Confirm",
    //cancelButtonProps: {size: 'large'},
    okButtonProps: {
      ...modalConfig("exclamation")?.okButtonProps,
      danger: true,
      ghost: true
    },
    onOk() {
      callBack(data)
    }
  })
}
